import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ViewportEmbed from "@/embed/ViewportEmbed";

const isEmbed = typeof window !== "undefined" && window.location.pathname.startsWith("/embed/viewport");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  isEmbed ? (
    <ViewportEmbed />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ),
);
